/* eslint-disable max-len */

export default {
  auth: {
    login: 'Login',
    access: 'Accedi',
    signUp: 'Registrazione',
    completeRegistration: 'Completa la registrazione',
    forgotPassword: 'Password dimenticata',
    forgotPasswordQuestion: 'Password dimenticata?',
    resendConfirmation: 'Invia email di conferma',
    rememberMe: 'Ricordami',
    register: 'Registrati',
    accountConfirmation: 'Conferma account',
    requestConfirmation: 'Conferma richiesta',
    newClient: 'Sei un nuovo allenatore? Registrati ora.',
    errors: {
      authRequired: 'Devi autenticarti per accedere a questa sezione.',
      noToken: "Mister c'è stato un problema con la tua richiesta. Prova più tardi.",
      status403: 'Username o password non validi.',
    },
    registration: {
      goToStep2: 'Vai allo step 2',
      goToStep3: 'Vai allo step 3',
      step1: 'Dati utente',
      coach: {
        step2: 'Dati anagrafici',
      },
      company: {
        step2: 'Dati società',
      },
      step3: 'Dati allenatore',
      billing: 'Dati di fatturazione',
      done:
        "Il tuo account è stato creato! Ti abbiamo inviato un'email con un link per confermarlo.",
      client: 'Sei già un nostro allenatore? ',
      login: 'Effettua il login',
      emailTaken:
        'Sei già iscritto! Risulti già registrato con questa email, accedi subito cliccando {0}',
      formEmailTaken: 'Questa email è già in uso',
    },
    confirmation: {
      confirming: "Sto confermando l'account...",
      confirmed: 'Complimenti, il tuo account è stato confermato!',
      goToDashboard: 'Accedi a Mistercalcio.com',
      emailNotSent: "Non ti è arrivata l'email di conferma?",
      emailSent: 'Ti è stata inviata una email di conferma, controlla la casella di posta!',
    },
    passwordReset: {
      emailSent:
        'Ti abbiamo inviato una email con le informazioni utili per recuperare la password.',
      success: 'La tua password è stata resettata con successo!',
    },
  },

  models: {
    user: {
      username: 'Username',
      password: 'Password',
      emailOrCardNumber: 'Email o numero tessera',
      new_password: 'Nuova password',
      passwordConfirmation: 'Conferma password',
      email: 'Email',
      name: 'Ragione sociale',
      code: 'Matricola',
      president: 'Presidente',
      faxNumber: 'Numero di fax',
      website: 'Sito web',
      nameRef: 'Nome referente',
      phoneNumberRef: 'Numero di telefono referente',
      emailRef: 'Email referente',
      skypeRef: 'Contatto skype referente',
      firstName: 'Nome',
      lastName: 'Cognome',
      phoneNumber: 'Numero di telefono',
      dateOfBirth: 'Data di nascita',
      cardNumber: 'Numero tessera',
      hints: {
        date: 'GG/MM/AAAA',
      },
      team: 'Squadra',
      facebook: 'Contatto Facebook',
      primaryRole: 'Ruolo primario',
      secondaryRole: 'Ruolo secondario',
      height: 'Altezza',
      weight: 'Peso',
      footNumber: 'Numero piede',
      primaryFoot: 'Piede',
      leftFoot: 'Sinistro',
      rightFoot: 'Destro',
      bothFeet: 'Ambidestro',
      shirtNumber: 'Numero di maglia',
      shirt: 'Maglia',
      foot1: 'Sinistro',
      foot2: 'Destro',
      foot3: 'Ambidestro',
      status: 'Stato',
      transferred: 'Trasferito',
      sold: 'Ceduto',
      onTrial: 'In prova',
      active: 'Attivo',
      statuses: {
        0: 'Trasferito',
        1: 'Prestito',
        2: 'In prova',
        3: 'Attivo',
      },
      statusDate: 'Data trasferimento / prestito',
      cfCode: 'Codice fiscale',
      idCode: 'Codice fiscale / Partita IVA',
      tosAgree: 'Confermo di aver letto e compreso i ',
      tos: 'termini di servizio',
      createdAt: 'Registrazione',
      lastLoginAt: 'Ultimo login',
      documentType: 'Tipo documento',
      documentNumber: 'Numero documento',
      documentReleasedBy: 'Documento rilasciato da',
      documentReleasedByHint: 'Massimo 14 caratteri. Esempio: Com. Agrigento',
    },
    address: {
      name: 'Nome e Cognome / Ragione Sociale',
      vat_id_code: 'Codice Fiscale / Partita IVA',
      line1: 'Indirizzo',
      line2: 'Scala, interno, etc.',
      city: 'Città',
      province: 'Provincia',
      zipCode: 'CAP',
      country: 'Paese',
    },
    season: {
      name: 'Nome',
      import: 'Importa i giocatori dalla stagione precedente',
      month: 'Mese di inizio allenamenti/partite',
      year: 'Anno di inizio allenamenti/partite',
      start: 'Inizio allenamenti',
      create: 'Crea stagione',
      update: 'Aggiorna stagione',
      created: 'Complimenti! La tua nuova stagione è stata creata con successo!',
      updated: 'Stagione aggiornata con successo',
      archive: 'Archivia stagione',
      archived: 'Stagione archiviata con successo',
      dearchive: 'Ripristina stagione',
      dearchived: 'Stagione ripristinata con successo',
      monthHint:
        'Le valutazioni generali dei propri giocatori (rosa) si basano su una raccolta per trimestri su base annuale. Questo significa che se imposti Gennaio come periodo di inizio avrai i seguenti trimestri: Gennaio-Marzo, Aprile-Giugno, Luglio-Settembre, Ottobre-Dicembre...',
      coach: 'Allenatore',
      exonerated: 'Esonerato',
    },
    exercise: {
      uses: 'Utilizzi',
      players: 'Giocatori',
      objects: 'Oggetti',
      backgrounds: 'Sfondi',
      title: 'Titolo',
      schema: 'Schema',
      description: 'Descrizione',
      materials: 'Materiale occorrente',
      primaryObjective: 'Obiettivo primario',
      secondaryObjective: 'Obiettivo secondario',
      categories: 'Categorie consigliate',
      playersNumber: 'Numero giocatori',
      exerciseMinutes: 'Minuti esercitazione',
      recoveryMinutes: 'Minuti di recupero',
      setsNumber: 'Numero di serie',
      recoveries: 'Numero di recuperi',
      totalTime: 'Tempo totale',
      share: 'Condividi',
      shareHint:
        'Gli esercizi condivisi possono essere uno spunto per tutti gli allenatori della Community Mistercalcio.com ed inseriti negli archivi personali',
      totalMinutes: 'Tempo totale: ',
      create: 'Crea esercizio',
      update: 'Aggiorna esercizio',
      objective: 'Obbiettivo',
      copies: 'Copie',
      likes: '0 like | 1 like | {count} like',
      comments: 'Cosa ne pensi di questo esercizio? Commenta qui sotto',
      comment: 'Commento',
      tags: 'Tag',
      tagsHint:
        'Inserisci qui le parole chiave che aiuteranno il tuo esercizio ad essere trovato più facilmente. NOTA: premi il tasto TAB o INVIO per aggiungere un tag.',
      quarter: 'Trimestre',
      difficulty: 'Difficoltà',
      difficulties: {
        1: 'Facile',
        2: 'Medio',
        3: 'Difficile',
      },
      easy: 'Facile',
      medium: 'Medio',
      hard: 'Difficile',
      coach: 'Allenatore',
      filters: {
        categories: 'Categorie',
        advancedFilters: 'Filtri Avanzati',
      },
      linkVideo: 'Link video da Youtube',
      hasVideo: 'Esercizi con video',
    },
    playerRole: {
      portiere: 'Portiere',
      terzino: 'Terzino',
      difensoreCentrale: 'Difensore centrale',
      difensore_centrale: 'Difensore centrale',
      esterno: 'Esterno',
      centrocampista: 'Centrocampista',
      trequarti: 'Trequarti',
      attaccante: 'Attaccante',
      ultimo: 'Ultimo',
      laterale: 'Laterale',
      universale: 'Universale',
      pivot: 'Pivot',
      goalkeeper: 'Portieri',
      defense: 'Difensori',
      center: 'Centrocampisti',
      attack: 'Attaccanti',
      universal: 'Universali',
    },
    training: {
      name: 'Allenamento',
      coach: 'Allenatore',
      title: 'Titolo',
      startAt: 'Data',
      startAtTime: 'Ora',
      present: 'Presente',
      notPresent: 'Assente',
      injured: 'Infortunato',
      differentiated: 'Differenziato',
      note: 'Note',
      month: 'Mese',
      prefilledTitle: 'Allenamento del {date}',
      comments: 'Cosa ne pensi di questo allenamento? Commenta qui sotto',
    },
    trainingPhase: {
      title: 'Titolo',
      description: 'Descrizione',
      playersNumber: 'Numero giocatori',
      trainingMinutes: 'Minuti esercitazione',
      sets: 'Numero di serie',
      recoveryMinutes: 'Minuti di recupero',
      recoveries: 'Numero di recuperi',
      exercise: 'Esercizio',
      players: 'Giocatori',
      totalMinutes: 'Tempo totale',
      parallel: 'Fase parallela alla precedente',
      differentiated: 'Allenamento differenziato',
    },
    match: {
      type: 'Competizione',
      championship: 'Campionato',
      cup: 'Coppa',
      friendly: 'Amichevole',
      duration: 'Durata',
      playersNumber: 'Numero giocatori',
      opponentName: 'Avversario',
      home: 'Partita in casa',
      homeHint: 'La partita è in casa',
      awayHint: 'La partita è in trasferta',
      player: 'Giocatore',
      day: 'Giornata',
      goals: 'Goal',
      substitutions: 'Sostituzioni',
      admonitions: 'Ammonizioni',
      expulsions: 'Espulsioni',
      notes: 'Note',
      homeFilter: 'Casa',
      awayFilter: 'Fuori casa',
      none: 'Nessuno',
      types: {
        all: 'Tutte',
        championship: 'Campionato',
        cup: 'Coppa',
        friendly: 'Amichevole',
      },
      scuolaCalcio: 'Scuola Calcio',
      multipleSubstitution: 'Sostituzioni multiple',
    },
    matchKick: {
      name: 'Nome del calcio piazzato',
      search: 'Cerca calcio piazzato per nome',
    },
    subscription: {
      date: 'Data',
      period: 'Periodo abbonamento',
      total: 'Totale',
      status: 'Stato',
      payed: 'Pagato',
      notPayed: 'Non pagato',
      payedAt: 'Pagato il',
      plan: 'Piano',
    },
    coach: {
      name: 'Nome',
      email: 'Email',
      category: 'Categoria',
      active: 'Attivo',
    },
    plan: {
      free: 'Base',
      basic: 'Super',
      free_company: 'Base per società',
      basic_company: 'Super per società',
      vcorsi: 'VCorsi',
    },
    player: {
      documentTypes: {
        ci: "Carta d'identità",
        pg: 'Patente di guida',
        p: 'Passaporto',
      },
    },
  },

  socialcalcio: {
    national: 'Nazionale',
    regional: 'Regionale',
    region: 'Regione',
    category: 'Categoria',
    tournament: 'Torneo',
    group: 'Gruppo',
    team: 'Squadra',
  },

  form: {
    send: 'Invia',
    next: 'Avanti',
    update: 'Aggiorna',
    selectFile: 'Seleziona file',
    uploadAvatar: 'Carica Immagine',
    uploadImage: 'Carica immagine',
    changePassword: 'Cambia password',
    currentPassword: 'Password corrente',
    newPassword: 'Nuova password',
    passwordConfirmation: 'Conferma password',
    passwordChanged: 'La tua password è stata cambiata con successo!',
    profileChanged: 'Il profilo è stato aggiornato con successo!',
    uploadAlert: "Rimani su questa pagina durante l'upload e attendi che il trasferimento del video sia completato al 100%. Riceverai una notifica via app / email non appena il video caricato sarà disponibile tra i tuoi video personali."
  },

  editor: {
    player: {
      remove: "Rimuovi dall'editor",
    },
    players: 'Giocatori',
    line: 'Linea',
    dashedLine: 'Linea tratteggiata',
    color: 'Colore',
    opacity: 'Trasparenza',
    curve: 'Curva',
    arrow: 'Freccia',
    dashedArrow: 'Freccia tratteggiata',
    triangle: 'Triangolo',
    rect: 'Rettangolo',
    circle: 'Cerchio',
    delete: 'Cancella selezionati (Backspace | Canc)',
    text: 'Testo',
    insert: 'Inserisci',
    enterText: 'Inserisci testo',
    enterDrawingMode: 'Entra in modalità disegno',
    exitDrawingMode: 'Esci dalla modalità disegno',
    lineWidth: 'Spessore linea',
    activate: "Voglio utilizzare l'editor",
    deactivate: "Non voglio utilizzare l'editor, voglio caricare un file",
    dialogTitle: 'Editor',
    dialogButton: 'Apri editor',
    closeDialog: 'Chiudi editor',
    changeToEditorButton: 'Cambia al nuovo editor',
    enterWavyMode: 'Entra in modalità disegno freccia ondulata',
    exitWavyMode: 'Esci dalla modalità disegno freccia ondulata',
    dashedWavy: 'Abilita linea tratteggiata',
    noDashedWavy: 'Disabilita linea tratteggiata',
    clone: 'Clona selezionati',
    download: 'Download fotogramma',
    save: 'Salva lavagna',
  },

  exercises: {
    created: 'Esercizio creato con successo!',
    updated: 'Esercizio aggiornato con successo!',
    searchFrom: 'Tra quali esercizi vuoi cercare?',
    myExercises: 'I miei esercizi!',
    misterCalcioExercises: 'Esercizi di MisterCalcio!',
    show: 'Visualizza',
    edit: 'Modifica',
    filters: 'Filtri',
    filter: 'Cerca esercizi',
    reset: 'Resetta campi',
    delete: 'Elimina',
    sure: 'Sei sicuro di voler eliminare questo esercizio?',
    trainingsAssociated:
      "0 | C'è un allenamento collegato ad esso. Andando avanti cancellerai anche il collegamento. | Ci sono {count} allenamenti collegati ad esso. Andando avanti cancellerai anche tutti i collegamenti.",
    deleted: 'Esercizio eliminato con successo!',
    clone: 'Copia Esercizio',
    createdBy: 'Creato da',
    cloned: 'Esercizio copiato con successo nei tuoi archivi!',
    comment: 'Commenta',
    duplicateError: "Non è stato possibile copiare l'esercizio. Riprova più tardi",
    select: 'Seleziona',
    aiSuggestion: 'Prendi Spunto',
    aiSuggestionTitle: 'Seleziona o rigenera l\'esercizio consigliato',
    aiGenerating: 'Stiamo generando il tuo esercizio',
    aiRegenerate: 'Rigenera',
    aiAccept: 'Accetta Suggerimento',
    aiRetryRequestError: 'Non siamo riusciti a generare il tuo esercizio. Ti chiediamo di effettuare un nuovo tentativo a breve',
    aiMaxRequestError: 'Hai raggiunto il numero massimo di richieste giornaliere',
    selectOne: 'Seleziona un esercizio',
    free:
      'Con il tuo profilo puoi vedere solo gli ultimi 5 esercizi. Per sbloccare gli altri, insieme a tutte ' +
      'le altre funzionalità di Mistercalcio.com',
    subscribe: 'abbonati',
    approve: 'Approva',
    reject: 'Rifiuta',
    rejectedChip: 'Rifiutato',
    toApprove: 'Da approvare',
    rejectedText: 'Questo esercizio è stato rifiutato dal responsabile della tua società',
    waitingForApproval:
      'Questo esercizio è in attesa di approvazione dal responsabile della tua società',
    approved: 'Complimenti Mister! Esercizio approvato con successo!',
    rejected: 'Questo esercizio NON è stato ritenuto idoneo dal responsabile della tua società!',
    saveExercise: 'Salva esercizio',
    saveKick: 'Salva calcio piazzato',
    keepOldImage: 'Mantieni immagine vecchia',
    keepOldImageHint:
      "Questo esercizio appartiene alla vecchia piattaforma. Per ragioni di compatibilità, se deselezioni questa opzione, l'immagine vecchia verrà sostituita. Mantieni questa opzione selezionata per prevenire la sovrascrittura.",
    mostUses: 'Esercizi più utilizzati',
    mostRecent: 'Esercizi recenti',
    mostClones: 'Esercizi più copiati',
  },

  kicks: {
    mostUses: 'Calci piazzati più usati',
    mostRecent: 'Calci piazzati recenti',
    mostClones: 'Calci piazzati più copiati',
    sure: 'Sei sicuro di voler eliminare questo calcio piazzato?',
    cloned: 'Calcio piazzato copiato con successo!',
    deleted: 'Calcio piazzato eliminato con successo!',
    filter: 'Cerca calci piazzati',
    created: 'Complimenti! Hai creato un nuovo Calcio piazzato!',
    updated: 'Questo Calcio piazzato è modificato con successo!',
  },

  users: {
    billingAddress: 'Dati di fatturazione',
    profile: 'Manage profile',
    logout: 'Logout',
    updateProfile: 'Aggiorna il tuo profilo',
    subscriptionExpired:
      'Attenzione! Il tuo abbonamento è scaduto in data {date}! Clicca {link} per rinnovarlo.',
  },

  players: {
    create: 'Crea giocatore',
    everyQuarter: 'Tutti i trimestri',
    quarter1: '1° trimestre',
    quarter2: '2° trimestre',
    quarter3: '3° trimestre',
    quarter4: '4° trimestre',
    heightHint: 'Altezza del giocatore in cm',
    weightHint: 'Peso del giocatore in kg',
    created: 'Giocatore creato con successo!',
    updated: 'Giocatore aggiornato con successo!',
    update: 'Aggiorna',
    player: 'Giocatore',
    role: 'Ruolo',
    ratings: 'Valutazioni',
    globalRating: 'Valutazione globale nei 4 trimestri',
    teamRating: 'Squadra',
    matchesPlayed: 'Partite giocate',
    minutesPlayed: 'Minuti giocati',
    goals: 'Goal',
    admonitions: 'Ammonizioni',
    expulsions: 'Espulsioni',
    attendances: 'Presenze allenamenti',
    injuries: 'Infortuni',
    avgRating: 'Voto medio',
    matchType: 'Tipo partita',
    confirm: 'Sei sicuro di voler eliminare il giocatore {player} ?',
    removed: 'Giocatore eliminato dalla rosa con successo!',
    coach: 'Allenatore',
    savePlayer: 'Salva giocatore',
    ratingPdfTitle: 'Valutazioni per {player} - {quarter} trimestre',
    printStats: 'Stampa',
    playersStats: 'Statistiche giocatori',
    videotags: 'Videotags',
    total: 'Totale giocatori disponibili',
    group: 'Gruppo',
  },

  seasons: {
    restore: 'Ripristina stagione',
    delete: 'Elimina stagione',
    deleted: 'Stagione eliminata con successo!',
    show: 'Visualizza stagione',
    quarter: 'Trimestre {quarter} dal {from} al {to}',
    hasToArchive: 'Vuoi veramente archiviare la stagione?',
    dearchive: 'Ripristino',
    deleteConfirmation:
      'ATTENZIONE: STAI PER ELIMINARE UNA STAGIONE INSERITA NEL SISTEMA. Confermando, non potrai più recuperare i dati della stagione stessa',
    oldSeasonAccess:
      'Non puoi accedere a questa sezione mentre stai studiando una stagione archiviata.',
    dearchiveDescription:
      "Puoi ripristinare l'ultima stagione in caso sia stata archiviata per errore.",
    showingArchivedSeason:
      'Stai visualizzando la stagione "{name}" di {date}. Clicca {link} per ripristinare la stagione corrente.',
  },

  ratings: {
    table: {
      name: 'Nome',
      noVote: 'Nessun voto',
      poor: 'Scarso',
      insufficient: 'Insufficiente',
      sufficient: 'Sufficiente',
      good: 'Buono',
      excellent: 'Eccellente',
    },
    saved: 'Complimenti! Valutazioni salvate con successo!',
    quarterNotStarted: 'Questo trimestre non è ancora iniziato! Sicuro di volerlo valutare?',
    quarterNotFinished: 'Questo trimestre non è ancora finito',
  },

  trainings: {
    byCoach: 'Allenatore {coach}',
    editAttendances: 'Modifica presenze',
    addAllPlayers: 'Seleziona tutti i giocatori',
    remAllPlayers: 'Deseleziona tutti i giocatori',
    addPhase: 'Aggiungi fase',
    phase: 'Fase {order}',
    addExercise: 'Aggiungi esercizio',
    changeExercise: 'Cambia esercizio',
    removeExercise: 'Rimuovi esercizio',
    removePhase: 'Rimuovi fase',
    clonePhase: 'Duplica fase',
    selectPlayers: 'Seleziona giocatori',
    created: 'Complimenti! Hai creato un nuovo Allenamento!',
    updated: 'Questo Allenamento è stato aggiornato con successo!',
    noPhases: 'Ogni allenamento deve avere una fase. Non ne hai inserita ancora nessuna!',
    noExercise: 'Nessun esercizio',
    cloned: 'Allenamento copiato con successo!',
    show: {
      title: 'Allenamento del {date}: {title}',
      phaseNumber: 'Fase {order}',
    },
    video: {
      title: '{title}: Video',
      addVideo: "Aggiungi video all'allenamento",
      line1: 'In questa sezione puoi aggiungere un link di un tuo video caricato su Youtube.',
      line2: 'Puoi caricare il video da {0} accendendo con il tuo account Youtube.',
      line3: 'Se non hai ancora un account puoi crearne uno {0}.',
      line4: 'Per aggiungere un video sul tuo account Mistercalcio:',
      line5:
        "Carica un video su Youtube scegliendo la categoria Sport e l'opzione Non elencato tra le impostazioni privacy.",
      line6:
        "Una volta caricato, il video avrà un URL del tipo: http://youtu.be/XXxxXXXxxxx. Puoi visualizzare l'url di un video già inserito alla pagina {0} cliccando sul menu Modifica -> Informazioni e impostazioni relativo al video di tuo interesse. ",
      line7:
        "Copia l'identificativo del video XXxxXXXxxxx nel campo di testo sottostante e conferma cliccando su INSERISCI VIDEO.",
      here: 'qui',
      videoHandling: 'Gestione Video',
      videoId: 'ID del video',
      insertVideo: 'Inserisci video',
      sure: "Sei sicuro di voler cancellare questo video dall'allenamento?",
      update: 'Aggiorna video',
      notValid: 'ID video non valido',
    },
    attendances: 'Inserisci presenze',
    attendancesSaved: 'Le Presenze sono state inserite con successo!',
    returnToTraining: "Ritorna all'allenamento",
    trainingsNumber: '0 allenamenti | 1 allenamento | {count} allenamenti',
    searchExercise: 'Cerca esercizio',
    print: 'Stampa',
    saveTraining: 'Salva allenamento',
    saveAndGoToTraining: "Inserisci le presenze e vai all'allenamento",
    confirm: 'Sei sicuro di voler cancellare questo allenamento?',
    removed: 'Allenamento rimosso con successo!',
    attendancesPdf: {
      title: 'Presenze allenamenti - {date}',
      print: 'Stampa presenze allenamenti',
    },
    availablePlayers: 'Giocatori disponibili',
    usedPlayers: 'Giocatori utilizzati',
    usablePlayers: 'Giocatori utilizzabili',
  },

  matches: {
    Video: 'Video',
    convocations: 'Convocazioni',
    addKick: 'Aggiungi calcio piazzato',
    convocationPlace: 'Luogo e orario della Convocazione',
    yourTeam: 'La Mia Formazione',
    theirTeam: 'La Formazione avversaria',
    addMatchPlayer: 'Aggiungi un giocatore',
    yourFormation: 'Il Mio Sistema di Gioco',
    yourFormation2: 'Cambio Sistema di Gioco in corso',
    theirFormation: 'Il Sistema di Gioco avversario',
    your: 'La Mia Squadra',
    their: 'Squadra Avversaria',
    addGoal: 'Aggiungi un goal',
    cloned: 'La partita è stata copiata con successo!',
    addSubstitution: 'Aggiungi una sostituzione',
    addAdmonition: "Aggiungi un'ammonizione",
    addExpulsion: "Aggiungi un'espulsione",
    exit: 'Esce',
    for: 'per',
    insertNotes: 'Inserisci delle note per la partita',
    created: 'La Partita è stata inserita con successo!',
    home: 'Casa',
    away: 'Trasferta',
    goals: 'Goal',
    datetime: 'Data/Ora',
    homeGoals: 'Goal casa',
    awayGoals: 'Goal trasferta',
    confirm: 'Sei sicuro di voler cancellare questa partita?',
    confirmWithVideo:
      '<strong style="color:red">Alert!</strong> Attenzione questa partita ha <strong>{countVideos}</strong> video e <strong>{countTags}</strong> tagli associati.<br>Eliminandola verranno eliminati tutti gli elementi.<br>Confermi la cancellazione della partita?',
    removed: 'Partita cancellata con successo!',
    goToMatch: 'Salva le convocazioni e vai alla partita',
    playerAttendances: 'Giocatori convocati',
    saveMatch: 'Salva partita',
    updated: 'Partita modificata con successo!',
    player: 'Giocatore',
    selectFormation: 'Seleziona una formazione',
    printDistinct: 'Stampa distinte',
    printAttendances: 'Stampa convocazioni',
    distinta1: 'Distinta 1',
    distinta2: 'Distinta 2',
    distinta3: 'Distinta 3',
    distinta4: 'Distinta 4',
    match: 'Partita',
    printMatch: 'Stampa partita',
    printMatchKicks: 'Stampa calci piazzati',
    printMatchFormation: 'Stampa formazione',
    editAttendances: 'Modifica convocazioni',
    saveAndGoToMatch: 'Salva e vai alla partita',
    convocationsEdited: 'La Convocazione è stata creata con successo!',
    yourEvents: 'I tuoi eventi',
    theirEvents: "Gli eventi dell'avversario",
    ratings: 'Valutazioni',
    kicks: 'Calci piazzati',
    info: 'Informazioni generali',
    distinctInfo: 'Info distinta',
    distinctInfoTitle: 'Informazioni aggiuntive per la stampa della Distinta 4',
    championship: 'Campionato',
    place: 'Presso',
    captain: 'Capitano',
    vice: 'Vice capitano',
    assistant: "Assistente dell'arbitro",
    manager: 'Dirigente accompagnatore ufficiale della squadra',
    manager2: 'Dirigente addetto ufficiali di gara',
    doctor: 'Medico Sociale',
    coach: 'Allenatore',
    coach2: 'Allenatore in seconda',
    massagist: 'Massaggiatore',
    company: 'Denominazione della Società',
    notes: 'Note',
    goalType: 'Tipo',
    goalType0: 'Generico',
    goalType1: 'Azione',
    goalType2: 'Punizione',
    goalType3: 'Rigore',
    goalType4: "Calcio d'angolo",
    goalType4Bis: 'Angolo',
    video: {
      title: '{title}: Video',
      addVideo: 'Aggiungi video alla partita',
      line1: 'In questa sezione puoi aggiungere un link di un tuo video caricato su Youtube.',
      line2: 'Puoi caricare il video da {0} accendendo con il tuo account Youtube.',
      line3: 'Se non hai ancora un account puoi crearne uno {0}.',
      line4: 'Per aggiungere un video sul tuo account Mistercalcio:',
      line5:
        "Carica un video su Youtube scegliendo la categoria Sport e l'opzione Non elencato tra le impostazioni privacy.",
      line6:
        "Una volta caricato, il video avrà un URL del tipo: http://youtu.be/XXxxXXXxxxx. Puoi visualizzare l'url di un video già inserito alla pagina {0} cliccando sul menu Modifica -> Informazioni e impostazioni relativo al video di tuo interesse. ",
      line7:
        "Copia l'identificativo del video XXxxXXXxxxx nel campo di testo sottostante e conferma cliccando su INSERISCI VIDEO.",
      here: 'qui',
      videoHandling: 'Gestione Video',
      videoId: 'ID del video',
      insertVideo: 'Inserisci video',
      sure: 'Sei sicuro di voler cancellare questo video dalla partita?',
      update: 'Aggiorna video',
      notValid: 'ID video non valido',
    },
    show: {
      buttonTitle: 'Visualizza',
      general: 'Informazioni generali',
      type: 'Tipo competizione',
      day: 'Giornata',
      date: 'Data',
      result: 'Risultato',
      duration: 'Durata',
      home: 'in casa',
      away: 'in trasferta',
      players: 'Giocatori',
      convocations: 'Convocazioni',
      formations: 'Formazioni',
      teams: 'Squadre',
      module: 'Modulo',
      changeModule: 'Cambio modulo',
      goals: 'Goal',
      substitutions: 'Sostituzioni',
      exits: 'Esce',
      for: 'per',
      admonitions: 'Ammonizioni',
      expulsions: 'Espulsioni',
      kicks: 'Calci piazzati',
    },
  },

  statistics: {
    skill: 'Capacità',
    percentage: 'Percentuale',
    teamAvg: 'Media squadra della capacità',
    goalsFatti: 'Goals fatti',
    goalsSubiti: 'Goals subiti',
    goalsFattiFt: 'Goals fatti primo tempo',
    goalsFattiSt: 'Goals fatti secondo tempo',
    goalsSubitiFt: 'Goals subiti primo tempo',
    goalsSubitiSt: 'Goals subiti secondo tempo',
    totali: 'Totali',
    from: 'Dal',
    to: 'Al',
  },

  subscriptions: {
    promo: 'Hai un codice sconto? Inseriscilo qui',
    payWithPaypal: 'Acquista o rinnova il tuo abbonamento cliccando il pulsante sottostante',
    description: 'Abbonamento {months} Mistercalcio.com, piano {plan}',
    success: 'Il pagamento è avvenuto con successo!',
    error: "C'è stato un errore nella tua richiesta: {error}",
    need:
      'Hai bisogno di un profilo SUPER per accedere a tutte le funzioni di Mistercalcio.com. Cosa Aspetti? Abbonati ora!',
    total: 'Totale:',
    promoUnlocked: 'Congratulazioni! Hai appena sbloccato uno sconto di €{amount}!',
    noBillingAddress:
      'Per poter rinnovare MisterCalcio.com è necessario compilare tutti i dati di fatturazione associati al tuo profilo utente.',
    noBillingAddress2: 'Compila ora, in pochi secondi, i tuoi dati di fatturazione - clicca {0}!',
  },

  coaches: {
    sendMessage: 'Invia messaggio',
    sendMessageText: 'Con questo strumento potrai inviare un messaggio ai tuoi allenatori',
    sendMessageSuccess: 'Il tuo messaggio è stato inviato con successo!',
    message: 'Messaggio',
    selectCoachId: 'Seleziona allenatore',
    selectCoachHint: 'Selezione un allenatore per mandare il messaggio solo a lui/lei',
    selectCoach: 'Selezione allenatore',
    created: 'Allenatore creato con successo!',
    createdButUnconfirmed:
      "L'allenatore è già presente. Gli è stata mandata una richiesta di conferma",
    archiveSeason: 'Archivia stagione',
    seasonArchived: 'Stagione archiviata con successo!',
    seasonRestored: 'Stagione ripristinata con successo!',
    exonerate: 'Esonera allenatore',
    exonerated: 'Allenatore esonerato con successo!',
    confirmRemove: 'Sei sicuro di voler esonerare questo allenatore? Pensaci bene!',
    invitation:
      'La società {company} vuole che tu inizi ad utilizzare Mistercalcio.com con tutte le funzionalità del profilo societario! Vuoi accettare?',
    accept: 'Accetta questo incarico',
    refuse: 'Rifiuto',
    restoreSeason: 'Ripristina stagione',
    changeCategory: 'Inserisci/Cambia categoria',
  },

  routes: {
    main: 'Mistercalcio',
    dashboard: 'Dashboard',
    profile: 'Manage profile',
    seasons: 'Seasons',
    season: 'Stagione',
    editSeason: 'Season edit',
    newSeason: 'Crea la tua stagione',
    seasonsArchive: 'Archivio stagioni',
    exercises: 'Exercises',
    newExercise: 'New exercise',
    editExercise: 'Modifica esercizio',
    myExercises: 'I miei esercizi',
    publicExercises: 'Esercizi di Mistercalcio',
    showExercise: 'Esercizio',
    kicks: 'Calci piazzati di Mistercalcio',
    newKick: 'Nuovo calcio piazzato',
    editKick: 'Modifica calcio piazzato',
    myKicks: 'I miei calci piazzati',
    publicKicks: 'Calci piazzati di Mistercalcio',
    companyKicks: 'Calci piazzati società',
    kicksToApprove: 'Calci piazzati da approvare',
    showKick: 'Calcio piazzato',
    squad: 'Squad',
    newPlayer: 'New player',
    players: 'Giocatori',
    editPlayer: 'Modifica giocatore',
    playersBaseTechnique: 'Tecnica di base',
    playersIndividualTactics: 'Tattica individuale',
    playersGoalkeeperTechnique: 'Tecnica del portiere',
    playersMotorSkills: 'Capacità motorie',
    playersMotorSkillsGoalkeeper: 'Capacità motorie (Portiere)',
    playersCollectiveTactics: 'Tattica collettiva',
    playersGameModulesAndSituations: 'Sistemi e situazioni di gioco',
    playersModulesSituations: 'Sistemi e situazioni di gioco',
    playersKicks: 'Calci piazzati',
    playerRatings: 'Valutazioni',
    playersStatistics: 'Statistiche',
    showPlayer: 'Visualizza',
    trainings: 'Trainings',
    newTraining: 'New training',
    editTraining: 'Modifica allenamento',
    showTraining: 'Allenamento',
    trainingAttendances: 'Presenze',
    trainingVideo: "Video dell'allenamento",
    matchVideo: 'Video della partita',
    myTrainings: 'I miei allenamenti',
    matches: 'Matches',
    newMatch: 'New match',
    editMatch: 'Modifica partita',
    myMatches: 'Le mie partite',
    statistics: 'Statistiche',
    objectives: 'Obiettivi',
    goals: 'Goals',
    subscriptions: 'Abbonamento',
    coaches: 'Allenatori',
    myCoaches: 'I miei allenatori',
    newCoach: 'Nuovo allenatore',
    companyExercises: 'Esercizi società',
    exercisesToApprove: 'Esercizi da approvare',
    companyPlayers: 'Giocatori società',
    matchAttendances: 'Inserisci convocazioni',
    newTrainingAttendances: 'Inserisci le presenze',
    newSubscription: 'Sottoscrivi un abbonamento',
    playersRatings: 'Valutazioni',
    settings: 'Impostazioni',
    matchAttendancesEdit: 'Modifica convocazioni',
    coach: 'Allenatore',
    sendMessage: 'Invia messaggio',
    notificationsHistory: 'Cronologia notifiche',
    notifications: 'Cronologia notifiche',
    renewSubscription: 'Rinnova abbonamento',
    billingAddress: 'Dati di fatturazione',
    subscribeNow: 'Abbonati ora',
    videotags: 'VideoTag',
    videotagTableau: 'Configurazione',
    videotagArchive: 'Archivio',
    videotagVideoTrainings: 'Video allenamenti',
    videotagVideoMatches: 'Video partite',
    videotagVideoManager: 'Gestione Video',
    newVideo: 'Nuovo video',
  },

  widgets: {
    socialcalcio: 'La Mia Squadra',
    calendar: 'Calendario',
    welcome: 'Benvenuto su MisterCalcio.com!',
  },

  calendar: {
    today: 'Oggi',
    newEvent: 'Nuovo evento',
    newMatch: 'Nuova partita',
    newTraining: 'Nuovo allenamento',
    date: 'Data',
  },

  table: {
    noExercises: 'Non abbiamo trovato nessun esercizio che corrisponda alla tua ricerca',
    noKicks: 'Non abbiamo trovato nessun calcio piazzato che corrisponda alla tua ricerca',
    noData: 'Nessun dato disponibile',
    noMatch: 'Nessun risultato trovato',
    rows: 'Righe per pagina:',
    actions: 'Azioni',
    kickRows: 'Calci piazzati per pagina:',
    exerciseRows: 'Esercizi per pagina:',
    notificationsRows: 'Notifiche per pagina:',
  },

  notifications: {
    read: 'Segna come letto',
    readAll: 'Segna tutto come letto',
    noNotifications: 'Non ci sono notifiche da leggere',
    billingAddressUpdated: 'I dati di fatturazione sono stati aggiornati con successo!',
    emailNotifications: {
      title: 'Notifiche per email',
      hint:
        "Abilita o disabilita l'invio delle notifiche tramite email. Questa funzione, se attivata, non ti obbligherà ad accedere a Mistercalcio.com per rimanere aggiornato",
    },
    generalMessageNotifications: {
      title: 'Messaggi da MisterCalcio.com',
      hint:
        'Se attivo MisterCalcio.com ti invierà dei messaggi personalizzati. Ad esempio notifiche Push sui contenuti esclusivi dal nostro blog',
    },
    hintsNotifications: {
      title: 'Collaboratore in seconda',
      hint:
        "Abilita o disabilita l'invio di messaggi automatici che solo un vero collaboratore in seconda si può ricordare di inviarti. Ti aiuteranno a tenere tutto sotto controllo",
    },
    playersMinutesNotifications: {
      title: 'Minuti per notifica giocatore',
      hint:
        'Imposta dopo quanti minuti giocati Mistercalcio ti invierà la notifica per complimentarsi con il giocatore',
    },
    playersGoalsNotifications: {
      title: 'Gol per notifica giocatore',
      hint:
        'Imposta dopo quanti gol effettuati Mistercalcio ti invierà la notifica per complimentarsi con il giocatore',
    },
    playersMatchesNotifications: {
      title: 'Partite per notifica giocatore',
      hint:
        'Imposta dopo quante partite giocate Mistercalcio ti invierà la notifica per complimentarsi con il giocatore',
    },
    playersInjuriesNotifications: {
      title: 'Infortuni per notifica giocatore',
      hint:
        'Imposta dopo quanti infortuni Mistercalcio ti invierà la notifica per richiamare il giocatore',
    },
    playersPositiveAvgNotifications: {
      title: 'Media voto positiva per notifica giocatore',
      hint:
        'Imposta la media voto base sopra la quale Mistercalcio ti invierà la notifica per complimentarsi con il giocatore',
    },
    playersNegativeAvgNotifications: {
      title: 'Media voto negativa per notifica giocatore',
      hint:
        'Imposta la media voto base sotto la quale Mistercalcio ti invierà la notifica per richiamare il giocatore',
    },
  },

  settings: {
    saved: 'Le tue Impostazioni sono state aggiornate con successo!',
  },

  errors: {
    error500: "C'è stato un problema con la tua richiesta. Prova più tardi.",
    error405: "C'è stato un problema con la tua richiesta. Prova più tardi.",
    error401: 'Non hai i permessi necessari per accedere a questa sezione',
    error413: 'Hai caricato un immagine troppo grande.',
    noSeason: 'Prima di continuare devi creare la tua stagione.',
    unauthorized: 'Non sei autorizzato ad accedere a questa pagina',
    pageNotFound: 'Pagina non trovata',
  },

  validation: {
    kickName: {
      required: 'Il nome del calcio piazzato è obbligatorio',
    },
    opponentName: {
      required: "Il nome dell'avversario è obbligatorio",
    },
    day: {
      required: 'Il numero della giornata è obbligatorio',
      number: 'La giornata deve essere un numero',
    },
    required: 'Campo obbligatorio',
    integer: 'Devi inserire un numero',
    positive: 'Devi inserire un numero positivo',
    email: {
      invalid: 'Inserisci per favore una email valida',
    },
    player: {
      required: 'Il giocatore è un campo obbligatorio',
    },
    password: {
      confirm: 'Le password non sono uguali',
      min: 'La password deve avere minimo 6 caratteri',
    },
    date: {
      invalid: 'Per favore inserisci una data valida (Formato: GG/MM/AAAA)',
    },
    number: {
      invalid: 'Per favore inserisci un numero valido',
      between: 'Il campo deve essere compreso tra {min} e {max}',
    },
    time: {
      invalid: 'Ora non valida',
    },
    goals: {
      minuteRequired: 'Il minuto del goal è obbligatorio',
      minutePositive: 'Il minuto del goal deve essere un numero positivo',
      playerRequired: 'Il giocatore del goal è obbligatorio',
    },
    substitutions: {
      minuteRequired: 'Il minuto della sostituzione è obbligatorio',
      minutePositive: 'Il minuto della sostituzione deve essere un numero positivo',
      playerRequired: 'Il giocatore della sostituzione è obbligatorio',
    },
    admonitions: {
      minuteRequired: "Il minuto dell'ammonizione è obbligatorio",
      minutePositive: "Il minuto dell'ammonizione deve essere un numero positivo",
      playerRequired: "Il giocatore dell'ammonizione è obbligatorio",
    },
    expulsions: {
      minuteRequired: "Il minuto dell'espulsione è obbligatorio",
      minutePositive: "Il minuto dell'espulsione deve essere un numero positivo",
      playerRequired: "Il giocatore dell'espulsione è obbligatorio",
    },
  },

  common: {
    notRequired: 'Campo non obbligatorio',
    kicks: 'Calci piazzati',
    report: 'Segnala',
    reportCommentTitle: 'Segnala commento',
    reportCommentText: 'Sei sicuro di voler segnalare il commento?',
    reportSuccess: 'La tua segnalazione è stata inviata con successo!',
    all: 'Tutto',
    close: 'Chiudi',
    appName: 'Mistercalcio',
    or: 'oppure',
    warning: 'Attenzione',
    cancel: 'Annulla',
    minutes: '0 minuti | 1 minuto | {count} minuti',
    months: '0 mesi | 1 mese | {count} mesi',
    sure: 'Sei sicuro?',
    edit: 'Modifica',
    save: 'Salva',
    show: 'Visualizza',
    ok: 'OK',
    filter: 'Filtra',
    search: 'Cerca',
    results: 'Risultati',
    loadMore: 'Carica altro',
    filters: 'Filtri',
    date: 'Data',
    time: 'Ora',
    minute: 'Minuto',
    remove: 'Rimuovi',
    yes: 'Si',
    no: 'No',
    backToHome: 'Torna alla homepage',
    print: 'Stampa',
    video: 'Video',
    moveUp: 'Sposta su',
    moveDown: 'Sposta giù',
    subscriptionNeeded: 'Hai bisogno di un abbonamento SUPER per accedere a questa funzionalità',
    firstLogin:
      'A causa della migrazione dei dati sulla nuova piattaforma, dovrai recuperare la password per sicurezza.',
    errors: 'Ci sono degli errori nella tua richiesta. Controlla e riprova',
    clone: 'Copia',
    exonerate: 'Esonera',
    here: 'qui',
    unknownPlayer: 'Giocatore sconosciuto',
    see: 'Vedi',
    likes: 'Like',
    copies: 'Copie',
    delete: 'Elimina',
    timeHint: 'Formato: OO:MM',
    dateHint: 'Formato: GG/MM/AAAA',
    notMoreShow: 'Non mostrare più',
  },

  months: {
    january: 'Gennaio',
    february: 'Febbraio',
    march: 'Marzo',
    april: 'Aprile',
    may: 'Maggio',
    june: 'Giugno',
    july: 'Luglio',
    august: 'Agosto',
    september: 'Settembre',
    october: 'Ottobre',
    november: 'Novembre',
    december: 'Dicembre',
  },

  privacy: {
    header: 'Accettazione della privacy',
    privacyAgree: 'Confermo di aver letto e accettato la {0}*',
    cookieAgree: 'Confermo di aver letto e accettato la {0}*',
    tosAgree: 'Confermo di aver letto e accettato i {0}*',
    privacyLink: 'Privacy Policy - Adeguamento al GDPR',
    cookieLink: 'Cookie Policy',
    tosLink: "Termini e condizioni d'utilizzo",
    headerCommercial: 'Invio offerte e informazioni commerciali',
    commercialAccept: 'Sì, per favore, vorrei ricevere offerte e informazioni commerciali.',
    commercialDenial: 'No grazie, non voglio ricevere offerte e informazioni commerciali.',
    commercialDescription:
      'Vorremmo inviarti informazioni su come utilizzare le nostre soluzioni, notizie e offerte speciali via e-mail, posta, telefono e altri mezzi elettronici. Tratteremo sempre le tue informazioni personali con la massima cura e trasparenza.',
  },

  help: {
    intro:
      "Hai riscontrato un problema oppure hai una domanda da farci? Contattaci all'indirizzo email {0} e ti risponderemo il più presto possibile.",
  },

  footer: {
    cookie: 'Cookie policy',
    tos: 'Termini e condizioni di utilizzo',
    privacy: 'Privacy',
    company: 'Digital Sport Mate srl P.I. 02983210598',
  },

  videotags: {
    skills: {
      name: 'Nome',
      beforeSeconds: 'Secondi prima',
      laterSeconds: 'Secondi dopo',
      color: 'Colore',
      order: 'Ordine',
      active: 'Attivo',
      new: 'Nuovo evento',
      edit: 'Modifica evento',
      noSkill: 'Nessun evento inserito',
      created: 'Evento creato con successo!',
      updated: 'Evento aggiornato con successo!',
      removed: 'Evento eliminato con successo!',
      confirm: 'Sei sicuro di voler eliminare questo evento?',
    },
    video: {
      title: 'Titolo del video',
      untitled: 'Video senza titolo',
      loaded: 'Video',
      newUpload: 'Carica video',
      selectVideo:
        'Puoi aggiungere un video tra quelli precedentemente caricati sul tuo spazio, selezionandolo dal menu a tendina',
      uploadVideo: 'Se non hai ancora caricato il video sul tuo spazio. Clicca',
      here: 'qui',
      source: 'Sorgente',
      all: 'Tutti i video',
      youtube: 'Video da YouTube',
      personal: 'Video personali',
      inserted: 'Inserito il',
      removed: 'Video eliminato con successo!',
      warning: 'ATTENZIONE! Verranno eliminati i tags ad esso associati.',
      save: 'Salva video',
      newMatch: 'Se non hai ancora creato la partita. Clicca',
      newTraining: "Se non hai ancora creato l'allenamento. Clicca",
      created: 'Video aggiunto con successo!',
      updated: 'Video modificato con successo!',
      youtubeLine1:
        'In questa sezione puoi aggiungere un link di un tuo video caricato su YouTube oppure un link di un video già presente all’interno di YouTube.',
      youtubeLine2:
        'Una volta scelto il video devi semplicemente incollare qui sotto la sua url di tipo https://www.youtube.com/watch?v=XXxxXXXxxxx oppure solamente l’identificativo del video XXxxXXXxxxx.',
      filename: 'Nome del file',
      uploadedAt: 'Caricato il',
      filesize: 'Dimensione',
      deleteConfirm: 'Sei sicuro di voler eliminare questo video?',
      totalSize: 'Spazio totale occupato',
      preview: 'Anteprima',
    },
    bookmarks: {
      i1t: 'Inizio 1° tempo',
      f1t: 'Fine 1° tempo',
      i2t: 'Inizio 2° tempo',
      f2t: 'Fine 2° tempo',
      i1ts: 'Inizio 1° tempo suppl.',
      f1ts: 'Fine 1° tempo suppl.',
      i2ts: 'Inizio 2° tempo suppl.',
      f2ts: 'Fine 2° tempo suppl.',
      ir: 'Inizio rigori',
      fr: 'Fine rigori',
      add: 'Segnalibro',
      created: 'Segnalibro creato con successo!',
      deleted: 'Segnalibro eliminato con successo!',
      deleteConfirm: 'Sei sicuro di voler eliminare questo segnalibro?',
    },
    layout: {
      enable: 'Abilita modifica layout',
      disable: 'Disabilita modifica layout',
      save: 'Salva il layout corrente',
      load: 'Carica il tuo layout',
      default: 'Apri layout di default',
      message:
        'Personalizza il tuo layout: sposta / ridimensiona i vari blocchi e salva il tuo layout preferito',
      archive: 'Archivio tags',
      events: 'Eventi tags',
      timeline: 'Timeline tags',
      summary: 'Tag',
      setting: 'Setting specifiche tag',
      fullscreenOn: 'Abilita full screen',
      fullscreenOff: 'FS off',
      fullscreenOffTitle: 'Disabilita full screen',
      saved: 'Layout salvato con successo!',
      tacticalBoard: 'Lavagna tattica',
      tacticalBoardOn: 'Abilita lavagna tattica',
      tacticalBoardOff: 'Chiudi lavagna tattica',
      tagsShow: 'Mostra Archivio tags',
      tagsHide: 'Nascondi Archivio tags',
      videoShow: 'Mostra Video',
      videoHide: 'Nascondi Video',
      skillsShow: 'Mostra Eventi tags',
      skillsHide: 'Nascondi Eventi tags',
      playersShow: 'Mostra Giocatori',
      playersHide: 'Nascondi Giocatori',
      tagShow: 'Mostra Tag',
      tagHide: 'Nascondi Tag',
      fieldShow: 'Mostra Setting specifiche tag',
      fieldHide: 'Nascondi Setting specifiche tag',
      timelineShow: 'Mostra Timeline',
      timelineHide: 'Nascondi Timeline',
    },
    plural: 'Videotags',
    event: 'Evento',
    generic: 'Generico',
    deleteConfirm: 'Sei sicuro di voler eliminare il tag',
    label: 'Rif.tag',
    who: 'Chi',
    begin: 'Inizio',
    end: 'Fine',
    type: 'Tipo',
    weight: 'Peso',
    where: 'Campo',
    zonaCampo: 'Zona del campo',
    note: 'Note',
    negative: 'Negativo',
    positive: 'Positivo',
    defensive: 'Difensivo',
    offensive: 'Offensivo',
    sigle_negative: 'Neg',
    sigle_positive: 'Pos',
    sigle_defensive: 'Dif',
    sigle_offensive: 'Off',
    created: 'Videotag creato con successo!',
    updated: 'Videotag modificato con successo!',
    deleted: 'Videotag eliminato con successo!',
    selectVideo: 'Per visualizzare un videotag devi prima caricare il video ad esso associato.',
    delTag: 'Elimina',
    downClip: 'Download',
    downloadConfirm: 'Confermi il download del tag',
    multiDownloadConfirm: 'Confermi il download dei tags selezionati?',
    download:
      'Richiesta di download inviata con successo! Riceverai a breve una notifica con il link del download.',
    all: 'Tutti',
    match: 'Partita',
    training: 'Allenamento',
    matches: 'Partite',
    trainings: 'Allenamenti',
    noDownload: 'Download non disponibile!',
    noDownMsg: 'Non puoi scaricare la clip perchè è associata o ad un video Youtube o ad un video che hai eliminato dal tuo archivio e/o è di durata superiore a 2 minuti.',
    team: 'Squadra',
    player: 'Giocatore',
    field1: 'Difesa',
    field2: 'Centrocampo',
    field3: 'Attacco',
    month: 'Mese',
    resetFilter: 'Resetta filtri',
    total: 'Tags totali',
    selected: 'Tags selezionati',
    reset: 'Resetta selezione',
    noAccess: "Spiacente! Non sei abilitato all'utilizzo del modulo Videotag.",
    pro: 'Funzionalità disponibile nella versione VideoTag Pro.',
    noTagFound: 'Nessun tag trovato!',
    modifySearch: 'Modifica i filtri di ricerca.',
    tacticalBoardSaved: 'Lavagna tattica salvata con successo!',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en.js